import { msg } from '@lingui/core/macro';

export const SHARED_RESET_PASSWORD_MODAL_TITLE = msg`Reset account?`;
export const SHARED_RESET_PASSWORD_MODAL_DESCRIPTION = msg`You’ll receive an email with a temporary password to reset your login credentials.`;
export const SHARED_RESET_PASSWORD_MODAL_CONFIRM = msg`Confirm`;
export const SHARED_RESET_PASSWORD_MODAL_CANCEL = msg`Cancel`;
export const SHARED_RESET_PASSWORD_MODAL_CONFIRMED_TITLE = msg`Reset request confirmed`;
export const SHARED_RESET_PASSWORD_MODAL_RESET_REQUEST_CONFIRMED = msg`Your temporary password reset request has been submitted. You’ll receive an email with reset instructions shortly. If it doesn’t arrive, check your spam folder or contact your company.`;
export const SHARED_RESET_PASSWORD_MODAL_BACK_TO_LOGIN = msg`Back to Login`;
export const SHARED_RESET_PASSWORD_MODAL_UNKNOWN_ERROR = msg`Unknown error occurred. Verify e-mail address.`;
